import { Signin } from '@/modules/auth/components/signin';

export const SigninPage = () => {
  return <Signin />;
};
